import type { Ref } from "react";
import { forwardRef, useRef } from "react";
import clsx from "clsx";
import { mergeRefs } from "react-merge-refs";

import { BaseInput } from "../baseInput/baseInput";
import rootClasses from "../styles.module.scss";
import { HintText } from "../hintText";

import type { ITextInputProps } from "./types";

import { Icon } from "@/components/atoms/icon";

export const TextInput = forwardRef(function TextInput(
  props: ITextInputProps,
  ref: Ref<HTMLInputElement>,
) {
  const {
    isInvalid,
    inputSize = "medium",
    onValueChange,
    onChange,
    iconName,
    endIconNam,
    startChildren,
    endChildren,
    readOnly,
    disabled,
    hintText,
    rootClassName,
    superRootClassName,
    ...rest
  } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <HintText
      disabled={disabled}
      isInvalid={isInvalid}
      text={hintText}
      className={superRootClassName}
    >
      <div
        className={clsx([rootClasses.inputBox, rootClassName])}
        onMouseDown={(event) => {
          event.preventDefault();
          inputRef.current?.focus();
        }}
        data-isinvalid={isInvalid}
        data-size={inputSize}
        data-read-only={readOnly}
        data-disabled={disabled}
      >
        {iconName && (
          <Icon name={iconName} className={"icon"} fontSize={"fs-20"} />
        )}
        <BaseInput
          ref={mergeRefs([inputRef, ref])}
          readOnly={readOnly}
          disabled={disabled}
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onChange={(event) => {
            onChange?.(event);
            onValueChange?.(event.target.value);
          }}
          {...rest}
        />
        {endChildren}
      </div>
    </HintText>
  );
});
